var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "hheader oddsboost" },
    [
      _c("section", { staticClass: "head" }, [
        _c(
          "h4",
          [
            _c("icon", {
              attrs: {
                colorName: "white",
                name:
                  "icon-" +
                  ((_vm.idfosporttype && _vm.idfosporttype.replace(/ /g, "")) ||
                    "empty")
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "coupontitle" }, [
              _vm._v(_vm._s(_vm.coupontitle))
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      [
        _c("section", { staticClass: "markets-header layout" }, [
          _c("div", { class: ["markets-title"] }, [
            _c("h4", { staticClass: "big3-market-name" }, [_vm._v("WAS")])
          ]),
          _vm._v(" "),
          _c("div", { class: ["markets-title"] }, [
            _c("h4", { staticClass: "big3-market-name" }, [_vm._v("NOW")])
          ])
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b3ab8c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b3ab8c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/oddsBoost/oddsBoostMarketsHeader.vue
// module id = null
// module chunks = 